(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    const forms = document.querySelectorAll('form.cv-form');
    if (!forms.length) return;

    function toE164AU(raw) {
      if (!raw) return '';
      const digits = String(raw).replace(/\D+/g, '');
      if (digits.startsWith('614') && digits.length === 11) return '+' + digits;
      if (digits.startsWith('04') && digits.length === 10) return '+61' + digits.slice(1);
      if (digits.startsWith('4') && digits.length === 9) return '+61' + digits;
      return '';
    }

    forms.forEach(function (form) {
      function setHint(input, show) {
        const name = input.getAttribute('data-cv-validate');
        if (!name) return;
        const hint = form.querySelector('[data-cv-hint="' + name + '"]');
        if (!hint) return;
        hint.hidden = !show;
        input.setAttribute('aria-invalid', show ? 'true' : 'false');
      }

      // Live-clear hint when the field becomes valid
      form.addEventListener('input', function (e) {
        const t = e.target;
        if (t && t.hasAttribute('data-cv-validate') && t.checkValidity()) setHint(t, false);
      });

      form.addEventListener('submit', function () {
        // Normalise phone to E.164 right before Shopify receives the POST
        const phoneInput = form.querySelector('input[name="contact[phone]"]');
        if (phoneInput && phoneInput.value) {
          const e164 = toE164AU(phoneInput.value);
          if (e164) phoneInput.value = e164;
        }
        // Expose hint on any invalid field with a custom pattern
        form.querySelectorAll('[data-cv-validate]').forEach(function (input) {
          if (!input.checkValidity() && input.value) setHint(input, true);
        });
      });
    });

    // On a success render, scroll the success block into view just below the sticky header.
    const success = document.querySelector('.cv-form__success');
    if (success) {
      try { success.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cv-chair-delivery-info"] && !Shopify.designMode) return;
  try {
    (function () {
    const nodes = document.querySelectorAll('[data-cv-chair-delivery]');
    nodes.forEach((node) => {
      let variants = {};
      try {
        variants = JSON.parse(node.dataset.variants || '{}');
      } catch (e) {}
      const headline = node.querySelector('[data-cv-chair-delivery-headline] span:last-child');
      if (!headline) return;
      document.addEventListener('variant:update', (event) => {
        const id = event.detail && event.detail.resource && event.detail.resource.id;
        if (!id) return;
        const entry = variants[String(id)];
        if (entry && entry.headline) headline.textContent = entry.headline;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cv-chair-per-chair-price"] && !Shopify.designMode) return;
  try {
    (function () {
    const nodes = document.querySelectorAll('[data-cv-chair-price]');
    nodes.forEach((node) => {
      let variants = {};
      try {
        variants = JSON.parse(node.dataset.variants || '{}');
      } catch (e) {}
      const label = node.querySelector('[data-cv-chair-price-label]');
      if (!label) return;
      document.addEventListener('variant:update', (event) => {
        const id = event.detail && event.detail.resource && event.detail.resource.id;
        if (!id) return;
        const entry = variants[String(id)];
        if (entry && entry.label) label.textContent = entry.label;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
